// extracted by mini-css-extract-plugin
export default {"root":"DishesTableProcessingLevel_root__W71j+","placeHolderShimmer":"DishesTableProcessingLevel_placeHolderShimmer__-PfCZ"};